import styled from "styled-components";

export const StyledInput = styled.input.attrs((props) => ({
  type: "text",
}))`
  width: 100%;
  background-color: transparent;
  color: ${(props) => props.theme.colors.typographyDefault};
  border: none;
  outline: none;
  font-family: ${(props) => props.theme.fonts.body.family};
  font-size: ${(props) => props.theme.fonts.body.fontSize};
  line-height: ${(props) => props.theme.fonts.body.lineHeight};
  font-weight: ${(props) => props.theme.fonts.body.fontWeight};
  letter-spacing: ${(props) => props.theme.fonts.body.letterSpacing};
  padding: 0;

  pointer-events: ${(props) => (props.disabled ? "none" : null)};
`;
